import React from 'react'
import './footer-consulting.scss'
import womanImg from '../../../assets/images/performance/medica.webp'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const FooterConsulting = (props) => {
    const {params} = props;

    return (
        <div className="f-footer-section">
            <div className="f-info-container">
                <img 
                    className="f-woman-img"
                    loading='lazy'
                    src={womanImg}
                    alt="Imagen mujer"
                />
                <div className="f-box-text-container">
                    <label className="f-footer-title">
                        <span className="f-puple-text">¡Súper</span> importante!
                    </label>
                    <div className="f-list-info-container">
                        {documentToReactComponents(params.informacionAdicionalConsultorios.json)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterConsulting
